export const COMPARE_PLAN_TABLE_DEFAULTS = {
  sectionId: "compare-all-plan-features",
} as const;

/** Offset for fixed header when using native in-page anchor scroll. */
export const COMPARE_PLAN_TABLE_SCROLL_MARGIN_TOP_PX = 130;
